export enum SpinnerSize {
  SM = 'sm',
  MD = 'md',
}
